import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import { CookieMonster } from 'root/utils/cookies/cookieMonster';
import { GeoMonster } from 'root/utils/cookies/geoMonster';

export default function CookieNotificationControllerInit(els) {
    els.forEach(el => {
        if (el) {
            const cn = new CookieNotificationController(el);
            return cn.load();
        }
    });
}

class CookieNotificationController {
    constructor(el) {
        this.el = el;
        this.hideClass = 'js-cookie-notification-null';
        this.globalHideClass = 'gb-hide';
        this.showClass = 'js-cookie-notification-display';
        this.cm = new CookieMonster();
        this.name = 'cookie-notification';
        this.gm = new GeoMonster();
    }

    // if the OptanonActiveGroups.split(',').filter(el => el !== '') is equal to 4 that means all 4 categories are granted.
    // that means that the user is browsing from a location where OT is not enabled
    // that means we can show the LS cookie banner
    // except from California where the OT banner is optin by default

    // however there could be a possibility that the user has granted all 4 categories and has reloaded the page
    // in that case we should check for the OptanonAlertBoxClosed cookie if it is set.
    // If it is set then we know that we should not show the LS cookie banner

    displayLogicCallbackBasedOnConsent() {
        const isCalifornia =
            this.gm.getField('country_code') === 'US' &&
            this.gm.getField('state_code' === 'CA');
        const isAllCategoriesGranted =
            window.OptanonActiveGroups.split(',').filter(el => el !== '').length === 4;

        const isOTDisabled =
            isAllCategoriesGranted &&
            !isCalifornia &&
            !this.cm.getCookie('OptanonAlertBoxClosed');
        if (!this.hasBeenClosed() && isOTDisabled) {
            this.el.classList.add(this.showClass);
            this.el.classList.remove(this.hideClass);
            this.el.classList.remove(this.globalHideClass);
            this.eventListener();
        }
    }

    load() {
        this.el.classList.add(this.hideClass);
        window.registerCookieComplianceCallback({
            callback: this.displayLogicCallbackBasedOnConsent.bind(this),
        });
    }

    eventListener() {
        let button = document.querySelector('[data-alert="accept-cookie_notification"]');
        button.addEventListener('click', this.closeHandler.bind(this));
        gtm.cookieNotification('').sendEvent('shown');
    }

    closeHandler(e) {
        e.preventDefault();
        this.cm.setCookie(this.getCookieName(), 1, 365);
        gtm.cookieNotification('').sendEvent('accept');
        this.postClosedActions();
    }

    postClosedActions() {
        this.el.classList.remove(this.showClass);
        this.el.classList.add(this.hideClass);
        gtm.cookieNotification('').sendEvent('exit');
    }

    hasBeenClosed() {
        let cookieValue = this.cm.getCookie(this.getCookieName());
        if (cookieValue === 1) {
            return true;
        }
        return false;
    }

    getCookieName() {
        return '_ls-' + this.name;
    }
}
